import { useCallback, useRef } from 'react'

import {
	TutorialStatus,
	useTutorialStore,
	wwtTutorialLog
} from '@wwt/core/tutorial'
import RestartTutorialPopup from '@wwt/widgets/popup/restart-tutorial'

import { useToast } from '@/shared/lib/hooks/useToast'

export const useShowTutorialRestartPopup = () => {
	const { setTutorialStatus } = useTutorialStore()
	const { toast } = useToast()

	const restartTutorialToast = useRef<ReturnType<typeof toast> | null>(null)

	const onClose = useCallback(() => {
		if (!restartTutorialToast.current) return

		wwtTutorialLog('Close restart popup')
		restartTutorialToast.current?.dismiss()
	}, [])

	const onSubmit = useCallback(() => {
		wwtTutorialLog('Set tutorial status to RESET')
		setTutorialStatus(TutorialStatus.RESET)

		onClose()
	}, [onClose, setTutorialStatus])

	const onOpen = useCallback(() => {
		restartTutorialToast.current = toast({
			layer: 'modals',
			className: 'pr-4',
			duration: Infinity,
			custom: (
				<RestartTutorialPopup
					onClose={onClose}
					onSubmit={onSubmit}
				/>
			)
		})
	}, [onClose, onSubmit, toast])

	return {
		onOpen,
		onClose
	}
}
